module.exports = __webpack_public_path__ + "img/angststoerungen_3000.1d8fbc1c.webp";